import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { BaseService } from "./baseService";

/** What `GET /push/key` answers when push notifications are switched on. */
export interface IPushKey {
    publicKey: string;
}

/** Which of the caller's browsers are sent a push notification. */
export class PushService extends BaseService {
    /**
     * The key a browser subscribes with, or `null` when this deployment has push switched off
     * -- which the API says with a 204, and which is how the page knows not to offer it.
     */
    getKey(): UseQueryOptions<IPushKey | null, Error> {
        return {
            queryKey: ['/push/key'],
            queryFn: async (): Promise<IPushKey | null> => {
                const key = await this.get<IPushKey | ''>('/push/key');

                return key && key.publicKey ? key : null;
            },
        };
    }

    /** Registers this browser to the caller. The body is the subscription as the browser serialises it. */
    subscribeMutation(): UseMutationOptions<void, Error, PushSubscriptionJSON> {
        return {
            mutationFn: (subscription: PushSubscriptionJSON): Promise<void> =>
                this.put<void>('/push/subscription', subscription),
        };
    }

    /** In the body, not the URL: the endpoint is a capability, and URLs end up in logs. */
    unsubscribeMutation(): UseMutationOptions<void, Error, string> {
        return {
            mutationFn: (endpoint: string): Promise<void> =>
                this.delete<void>('/push/subscription', { data: { endpoint } }),
        };
    }
}
